<div class="wrap wrapMain doc-upload">
  <form class="coverPathForm" id="uploadFormGroup" [formGroup]="uploadFormGroup">
    <div class="wrap wrapHead">
      <div class="pageHead">
        <h1>Upload Your Documents</h1>
      </div>
    </div>
    <div class="wrap wrapMain upload-container">
      <div class="upload-pane">
        <p class="upload-text">Please upload the necessary documents.</p>
        <p>(JPG,PNG and PDF Files only, each up to 5MB)</p>
        <img src="/img/icons/upload_gray.svg" class="upload-icon" />
        <hr />
        <input
          type="file"
          multiple
          class="upload-btn"
          accept="image/jpg, image/jpeg, image/png, image/gif, application/pdf"
          (change)="onChange($event)"
          (click)="onClick($event)"
          formControlName="fileChoose"
        />
        <p *ngIf="error" class="error">{{ error }}</p>
        <div *ngFor="let dataObj of uploadDocObjectList">
          <li>
            <div class="image-container" with="300">
              <div class="image-tile">
                <img [src]="dataObj.body" alt="" />
                <a (click)="deleteFile(dataObj.fileName)" class="delete-file-button"></a>
              </div>
              <div>
                <span>{{ dataObj.fileName }}</span>
              </div>
            </div>
          </li>
        </div>
        <canvas hidden id="pdf-canvas"></canvas>
      </div>
    </div>
    <div class="wrap wrapFoot PosCenter">
      <div class="cta">
        <button type="submit" class="btnSubmit" [disabled]="isDisabled()" (click)="confirm()">Submit</button>
        <button type="button" class="btnCancel" (click)="cancel()">Cancel</button>
      </div>
    </div>
  </form>
</div>
